// DEROS: lightbox for the brand and collection showcase galleries.
//
// The viewer itself is assets/deros-lightbox.js (the site's one image viewer,
// shared with the blog articles). This module only supplies its data source:
// every zoom link in the gallery, in DOM order, using the link's href (the
// original file), the dimensions it declares and its two caption attributes.
//
// If the viewer cannot load the click is not intercepted, so the link opens
// the full-size image on its own.

import { openDerosLightbox } from "deros-lightbox";

const GALLERY = ".deros-showcase__gallery";
const ZOOM = ".deros-showcase__zoom";

const gallery = document.querySelector(GALLERY);

if (gallery) {
  const links = Array.from(gallery.querySelectorAll(ZOOM));

  const slides = links.map((link) => ({
    src: link.href,
    width: Number(link.dataset.pswpWidth) || 1600,
    height: Number(link.dataset.pswpHeight) || 1200,
    alt: link.querySelector("img")?.getAttribute("alt") || link.getAttribute("aria-label") || "",
    // data-caption-1 does not camel-case (a dash before a digit stays literal),
    // so dataset.caption1 would be undefined; read the attributes directly.
    caption1: link.getAttribute("data-caption-1") || "",
    caption2: link.getAttribute("data-caption-2") || ""
  }));

  let opening = false;

  async function open(index) {
    // A second click while the first is still importing must not be treated as
    // a failure by the caller, or it would navigate away mid-open.
    if (opening) return true;
    opening = true;
    try {
      await openDerosLightbox(slides, index);
      return true;
    } catch (error) {
      console.error("[deros] could not open the image viewer:", error);
      return false;
    } finally {
      opening = false;
    }
  }

  gallery.addEventListener("click", (event) => {
    const link = event.target.closest(ZOOM);
    if (!link || !gallery.contains(link)) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    open(links.indexOf(link)).then((opened) => {
      // The viewer could not load: let the browser do what the link says.
      if (!opened) window.location.href = link.href;
    });
  });
}
